import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=06f0cdf4&scoped=true&"
import script from "./supervision.vue?vue&type=script&lang=js&"
export * from "./supervision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0cdf4",
  null
  
)

export default component.exports